__turbopack_context__.v({
  "bookYourFlight": "booking-form-module-scss-module__8YgHwW__bookYourFlight",
  "bookingform": "booking-form-module-scss-module__8YgHwW__bookingform",
  "buttonContainer": "booking-form-module-scss-module__8YgHwW__buttonContainer",
  "errorMessage": "booking-form-module-scss-module__8YgHwW__errorMessage",
  "firstline": "booking-form-module-scss-module__8YgHwW__firstline",
  "formblock": "booking-form-module-scss-module__8YgHwW__formblock",
  "inputContainer": "booking-form-module-scss-module__8YgHwW__inputContainer",
  "item": "booking-form-module-scss-module__8YgHwW__item",
  "item1": "booking-form-module-scss-module__8YgHwW__item1",
  "item2": "booking-form-module-scss-module__8YgHwW__item2",
  "tabactive": "booking-form-module-scss-module__8YgHwW__tabactive",
  "tabdefault": "booking-form-module-scss-module__8YgHwW__tabdefault",
  "tabdefault1": "booking-form-module-scss-module__8YgHwW__tabdefault1",
  "tabs": "booking-form-module-scss-module__8YgHwW__tabs",
});
